import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateGroup = (params) => {
    return axios.post(`${backendHost}/api/admin/cashiers/groups`, params);
};

export {
    postCreateGroup
}